import {ApolloClientOptions, InMemoryCache, NormalizedCacheObject} from "@apollo/client/core"
import {getHttpLink} from "@common/helpers/api/http-link"
import {loadErrorMessages, loadDevMessages} from "@apollo/client/dev"
import {isDevMode} from "@angular/core"

export const cmApolloConfig: () => ApolloClientOptions<NormalizedCacheObject> = () => ({
    link: getHttpLink(),
    cache: new InMemoryCache(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "no-cache",
        },
        query: {
            fetchPolicy: "no-cache",
        },
    },
})

if (isDevMode()) {
    loadDevMessages()
    loadErrorMessages()
}
